export const SITE = {
    name: "Pronto Auto Care",
    booksy: "https://prontoautocare.booksy.com/k/",
    instagram: "https://www.instagram.com/pronto.autocare",
    tiktok: "https://www.tiktok.com/@pronto.autocare",
    phoneDisplay: "(561) 481-2355",
    phoneHref: "tel:5614812355",
    area: "Miami • Broward • Palm Beach",
};

export const TikTokIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
);
